import {
  TRAVEL_ABOUT_STEP,
  TRAVEL_PRICE_STEP,
  travelCoverages,
} from "Components/Features/CheckPrice/Products/RiskProducts/Travel";

import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export function mapFromCommerceTravel(data: {
  [key: string]: any;
}): FormStates {
  const { damageCountRecentYears, yearOfLastDamage, coverageGroup } = data;
  const isInsuranceFor = booleanToFormBoolean(
    travelCoverages[coverageGroup].forInsuredOnly,
  );
  const injuries =
    damageCountRecentYears === 1
      ? DamageRecentYears.ONE
      : DamageRecentYears.NONE;
  const injuryYear =
    injuries === DamageRecentYears.ONE ? String(yearOfLastDamage) : undefined;

  return {
    [TRAVEL_ABOUT_STEP.id]: {
      isInsuranceFor,
      injuries,
      injuryYear,
    },
    [TRAVEL_PRICE_STEP.id]: {
      coverage: coverageGroup,
    },
  };
}
